import { render, staticRenderFns } from "./projetos-icon.vue?vue&type=template&id=302efad7&"
import script from "./projetos-icon.vue?vue&type=script&lang=js&"
export * from "./projetos-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports